<template>
  <div class="animated fadeIn">
    <b-form v-on:submit.prevent
            novalidate
            autocomplete="off">
      <b-card>
        <div slot="header">
          <h2>Login as</h2>
        </div>

        <b-row>
          <b-col>
            <b-form-group>
              <label for="impersonateUsername" class="eden__label__required">Log in as</label>
              <b-form-select id="impersonateUsername"
                             ref="impersonateUsername"
                             :options="isAuthenticated && userRoles.includes('TechAdmin') ? this.impersonateUsernames : [{ value: -1, text: 'Login first...' }]"
                             v-model="form.impersonateUsername"
                             :disabled="!isAuthenticated || !userRoles.includes('TechAdmin')"
                             aria-describedby="impersonateUsernameFeedback"
                             class="impersonateUsernameFeedback"></b-form-select>
              <b-form-invalid-feedback id="impersonateUsernameFeedback">
                This is a required field
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group>
              <label for="username" class="eden__label__required">Email</label>
              <b-form-input id="username"
                            ref="username"
                            v-model.trim="form.username"
                            :state="$v.form.username.$dirty ? !$v.form.username.$error : null"
                            aria-describedby="usernameFeedback"
                            placeholder="Email"
                            autocomplete="nope"
                            autocorrect="off"
                            autocapitalize="off"></b-form-input>
              <b-form-invalid-feedback id="usernameFeedback">
                This is a required field
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group>
              <label for="password" class="eden__label__required">Password</label>
              <b-form-input type="password"
                            id="password"
                            ref="password"
                            v-model.trim="form.password"
                            aria-describedby="passwordFeedback"
                            :state="$v.form.password.$dirty ? !$v.form.password.$error : null"
                            placeholder="Password"></b-form-input>
              <b-form-invalid-feedback id="passwordFeedback">
                This is a required field
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="isStaging">
          <b-col>
            <b-form-group>
              <b-form-checkbox v-model="ackStaging">
                I acknowledge this is the <strong>staging/test</strong> version of the portal and <strong>NOT</strong> for production use. 
                <br /><br />
                This environment may be periodically reset or unavailable!!<br /><br />
                To login to production, please use the main login page at <a href="https://portal.holisticindustries.net/login-impersonate" >https://portal.holisticindustries.net/login-impersonate</a>.
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col cols="12" xl="2" lg="3" md="6">
            <b-form-group>
              <b-button v-on:click="login"
                        ref="save"
                        id="save"
                        variant="primary"
                        class="w-100"
                        :disabled="isAuthenticated || !formIsValidLogin || (isStaging && !ackStaging)">
                <i class="fa fa-user mr-2"></i>
                Login
              </b-button>
            </b-form-group>
          </b-col>
          <b-col cols="12" xl="2" lg="3" md="6" v-if="isAuthenticated && userRoles.includes('TechAdmin')">
            <b-form-group>
              <b-button v-on:click="continueLoginAs"
                        ref="continueButton"
                        id="continueButton"
                        variant="success"
                        class="w-100"
                        :disabled="!formIsValidImpersonate">
                <i class="fa fa-arrow-right mr-2"></i>
                Continue Login As...
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </b-form>
    <b-modal id="impersonateFailure"
             title="Access Denied"
             size="md"
             ok-only
             ok-variant="danger"
             ok-title="Access Denied"
             @ok="redirectToStandardLogin">
      <b-row>
        <b-col cols="12">
          Only those with the TechAdmin role can impersonate other users
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="impersonateSuccess"
             title="Impersonating User"
             size="md"
             ok-title="Impersonate"
             @ok="impersonateUser"
             cancel-title="Logout"
             @cancel="logout">
      <b-row>
        <b-col cols="12">
          You are impersonating {{ form.impersonateUsername }}
        </b-col>
      </b-row><br />
      <b-row>
        <b-col cols="12">
          {{ form.impersonateUsername }} has the following groups:
        </b-col>
      </b-row><br />
      <b-row>
        <b-col cols="12">
          {{ impersonateGroups }}
        </b-col>
      </b-row><br />
      <b-row>
        <b-col cols="12">
          {{ form.impersonateUsername }} has the following roles:
        </b-col>
      </b-row><br />
      <b-row>
        <b-col cols="12">
          {{ impersonateRoles }}
        </b-col>
      </b-row>

    </b-modal>
  </div>
</template>
<script>
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'

  export default {
    mixins: [
      validationMixin,
    ],

    components: {
      
    },

    data() {
      return {
        ackStaging: false,
        isStaging: window.location.hostname.includes('staging') ||
                  window.location.hostname.includes('dev-portal'),
        form: {
          impersonateUsername: -1,
          username: null,
          password: null,
        },
        impersonateUsernames: [
          { value: -1, text: 'Please select an employee to impersonate' },
        ],
        impersonateGroups: [

        ],
        impersonateRoles: [

        ],
        isAuthenticated: false,
        userRoles: [],
      }
    },

    validations: {
      form: {
        impersonateUsername: { isValid: val => val != -1 },//{ isValid: val => val != -1 },//{ required },
        username: { required },
        password: { required },
      },
    },

    computed: {
      formIsValidImpersonate() {
        // Standard validation
        const baseValid = !this.$v.$invalid

        // Additional staging requirement
        if (this.isStaging) {
          return baseValid && this.ackStaging
        }

        return baseValid
      },
      // only validate username and password for initial login
      formIsValidLogin() {
        return !this.$v.form.username.$invalid && !this.$v.form.password.$invalid
      },
    },

    methods: {
      async login() {
        // Form validation
        this.$v.form.$touch()

        // Only validate username and password on initial login
        if (this.$v.form.username.$error || this.$v.form.password.$error) {
          this.$toasted.global.error({
            message: 'Please correct errors in form',
          })
          return
        }

        const loader = this.$loading.show()
        try {
          // First, authenticate the user with standard login
          const { data } = await this.$request({
            url: '/api/auth/login',
            method: 'post',
            data: {
              username: this.form.username,
              password: this.form.password,
            },
          })
          const groups = data?.user?.groups?.map(g => g.name)
          const roles = data?.user?.appRoles?.map(r => r.appRole.name)

          // Check if user has TechAdmin role
          if (!roles.includes('TechAdmin')) {
            this.$bvModal.show('impersonateFailure')
            loader.hide()
            return false
          }

          // User is authenticated and has TechAdmin role
          this.isAuthenticated = true
          this.userRoles = roles
          this.userGroups = groups

          // Store the token and auth state
          this.$store.commit('authToken', data?.token)
          this.$store.commit('userProfile', null)   // ✅ clear cached profile in Vuex

          // Now fetch the list of users to impersonate
          await this.getImpersonateUsernames()

          // Store our app version in local storage (optional, non-blocking)
          try {
            const res = await this.$request({
              method: 'get',
              url: '/build_version.json',
              headers: {
                Authorization: `Bearer ${data?.token}`,
              },
              params: {
                __ts: Date.now(),
              },
            })

            this.$log.info(`Stored app version: ${this.$store.getters.appVersion}`)
            this.$log.info(`Deployed app version: ${res.data.version}`)
            this.$store.commit('appVersion', res.data.version)
          } catch (e) {
            // build_version.json may not exist in dev environment, that's okay
            this.$log.debug('Could not fetch app version', e);
          }

          this.$toasted.global.success({
            message: 'Login successful. Select a user to impersonate.',
          })
        } catch (e) {
          this.$log.error('Error logging in', e)
          this.$toasted.global.error({
            message: 'Invalid credentials',
          })
          return
        } finally {
          loader.hide()
        }
      },

      async continueLoginAs() {
        // Form validation - only validate impersonateUsername
        if (this.form.impersonateUsername === -1) {
          this.$toasted.global.error({
            message: 'Please select a user to impersonate',
          })
          return
        }

        const loader = this.$loading.show()
        try {
          // Now make the impersonate call with all credentials
          const { data } = await this.$request({
            url: '/api/auth/login.impersonate.user',
            method: 'post',
            data: this.form,
          })
          const groups = data?.user?.groups?.map(g => g.groupName)
          const roles = data?.user?.appRoles?.map(r => r.appRoleName)

          this.impersonateRoles = roles.sort((a, b) => a.localeCompare(b))
          this.impersonateGroups = groups.sort((a, b) => a.localeCompare(b))

          // Update the token with the impersonated user's token
          this.$store.commit('authToken', data?.token)
          this.$store.commit('userProfile', null)   // ✅ clear cached profile in Vuex
          this.$store.commit('isImpersonating', true)

          // ✅ force profile load now so the rest of the app is stable
          await this.getUserProfile()

          this.$bvModal.show('impersonateSuccess')
        } catch (e) {
          this.$log.error('Error impersonating user', e)
          this.$toasted.global.error({
            message: 'Failed to impersonate user',
          })
          return
        } finally {
          loader.hide()
        }
      },

      async impersonateUser() {
        this.$log.info("impersonateUser")
        // Redirect if we ended up here from a session expire
        try {
          if (this.$store.getters.loginRedirect) {
            const redir = this.$store.getters.loginRedirect
            this.$store.commit('loginRedirect', null)
            return this.$router.push(redir)
          }
        } catch (e) {
          this.$log.error('Error redirecting user', e)
        }

        this.$router.push('/')
      },

      async getImpersonateUsernames() {
        try {
          const response = await this.$request({
            url: '/api/auth/list',
            method: 'get',
          })
          
          const userList = response?.data?.data || []

          if (!Array.isArray(userList)) {
            console.error("userList is not an array:", userList)
            this.$toasted.global.error({
              message: 'Invalid user list format received',
            })
            return
          }

        // add a fullName property to each user
        userList.forEach(user => {
          const nameParts = user.username.split("@")[0]
          
          // Handle external user format like "adelemariestew_gmail.com#ext#"
          let cleanedName = nameParts
          if (nameParts.includes('#ext#')) {
            cleanedName = nameParts.replace('#ext#', '').replace(/_gmail\.com$/, '').replace(/_/g, ' ')
          }
          
          const nameComponents = cleanedName.split(".")
          
          if (nameComponents.length >= 2) {
            // Handle firstname.lastname format
            var firstName = nameComponents[0] || ''
            var lastName = nameComponents[1] || ''
            firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1)
            lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1)
            user.fullName = `${firstName} ${lastName}`
          } else {
            // Handle single word usernames (like "agents") or cleaned external names
            const singleName = nameComponents[0] || ''
            const formattedName = singleName.charAt(0).toUpperCase() + singleName.slice(1)
            user.fullName = formattedName
          }
        })

        // sort users by first name and then last name
        var users = userList.sort((a, b) => {
          const namePartsA = a.username.split("@")[0]
          const namePartsB = b.username.split("@")[0]
          
          // Clean external user formats
          let cleanedNameA = namePartsA
          let cleanedNameB = namePartsB
          if (namePartsA.includes('#ext#')) {
            cleanedNameA = namePartsA.replace('#ext#', '').replace(/_gmail\.com$/, '').replace(/_/g, ' ')
          }
          if (namePartsB.includes('#ext#')) {
            cleanedNameB = namePartsB.replace('#ext#', '').replace(/_gmail\.com$/, '').replace(/_/g, ' ')
          }
          
          const nameComponentsA = cleanedNameA.split(".")
          const nameComponentsB = cleanedNameB.split(".")
          
          const firstNameA = (nameComponentsA[0] || '').toUpperCase()
          const lastNameA = (nameComponentsA[1] || '').toUpperCase()
          const firstNameB = (nameComponentsB[0] || '').toUpperCase()
          const lastNameB = (nameComponentsB[1] || '').toUpperCase()

          if (firstNameA < firstNameB) return -1
          if (firstNameA > firstNameB) return 1
          if (lastNameA < lastNameB) return -1
          if (lastNameA > lastNameB) return 1
          return 0
        })

        users.map(user => this.impersonateUsernames.push({ value: user.username, text: `${user.fullName} - ${user.username}` }))
        } catch (error) {
          console.error('Error in getImpersonateUsernames:', error)
          this.$toasted.global.error({
            message: 'Failed to process user list for impersonation',
          })
        }
      },

      async redirectToStandardLogin() {
        await this.$router.push('/login')
      },

      async logout() {
        try {
          this.$store.commit('reset')
        } catch (e) {
          this.$log.error('Error logging out user', e)
        }
        try {
          await this.$router.push('/login-impersonate')
        } catch (e) { }
        window.location.href = window.location.href
      },
    },

    async mounted() {
      // User list will be fetched only after successful TechAdmin login
      // This ensures the impersonation list is not visible before authentication
    },
  }
</script>